import { render, staticRenderFns } from "./profile-view.vue?vue&type=template&id=5656e426&scoped=true&"
import script from "./profile-view.vue?vue&type=script&lang=js&"
export * from "./profile-view.vue?vue&type=script&lang=js&"
import style0 from "./profile-view.vue?vue&type=style&index=0&id=5656e426&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5656e426",
  null
  
)

export default component.exports